import { render } from "./MenuComponent.vue?vue&type=template&id=615e15fc"
import script from "./MenuComponent.vue?vue&type=script&lang=js"
export * from "./MenuComponent.vue?vue&type=script&lang=js"

import "./MenuComponent.vue?vue&type=style&index=0&id=615e15fc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__